import React from "react"
import styled from "styled-components"
import RHeader from "../molecules/r-header"
import media from "styled-media-query"

const Wrap = styled.div`
  background-color: #0f59c0;
  border-radius: 5px;
  color: #fff;
  padding: 12px 12px 15px 12px;
  margin-top: 12px;
  ${media.greaterThan("small")`
    display: flex;
    padding: 10px 22px;
    margin-top: 17px;
  `}
`
const LeftWrap = styled.div`
  ${media.greaterThan("small")`
    width: 51%;
  `}
`
const RightWrap = styled.div`
  ${media.greaterThan("small")`
    flex: 1;
    padding: 16px 8px 16px 40px;
  `}
`
const RankImage = styled.div`
  height: calc(100% - 4px);
  margin: auto;
  width: 100%;
  ${media.greaterThan("small")`
    height: 100px;
  `}
`
const StyledH2 = styled.h2`
  color: #fff;
  font-size: 6.4vw;
  letter-spacing: 2px;
  margin: 5px 0 10px 0;
  ${media.greaterThan("small")`
    font-size: 40px;
  `}
`
const StyledImage = styled.img`
  border-radius: 5px;
  display: block;
  width: 100%;
`

const Awards = props => {
  const index = props.index
  const hText = props.hText
  const awardImage = props.awardImage
  return (
    <Wrap>
      <LeftWrap>
        <RHeader index={index} />
        <StyledH2>{hText}のあなたは...</StyledH2>
      </LeftWrap>
      <RightWrap>
        <RankImage>
          {/*<Image name={awardImage} />*/}
          <StyledImage src={awardImage} alt="awardImage" />
        </RankImage>
      </RightWrap>
    </Wrap>
  )
}
export default Awards
